export const BIZ_STEP_ICON_MAP = {
  "urn:epcglobal:cbv:bizstep:receiving": "box-2",      // ni-box-2
  "urn:epcglobal:cbv:bizstep:processing": "settings-gear-65",
  "urn:epcglobal:cbv:bizstep:assembling": "collection",
  "urn:epcglobal:cbv:bizstep:inspecting": "check-bold",
	"urn:epcglobal:cbv:bizstep:commissioning": "box-2",
  "urn:epcglobal:cbv:bizstep:packing": "archive-2",
  "urn:epcglobal:cbv:bizstep:shipping": "send",
  "urn:epcglobal:cbv:bizstep:transporting": "delivery-fast",
  "urn:epcglobal:cbv:bizstep:receiving_at_retail": "shop"
}